import React from 'react'

import {
  AppearingWrapper,
  CTAHeadline,
  SectionContainer,
} from 'Components/Blocks'
import { Button, Column, Row } from 'Components/UI'

import {
  LANDING_CONTENT_PX,
  LANDING_CONTENT_WIDTH_PX,
  LANDING_SECTION_GAP,
  LANDING_SECTION_PY,
} from 'Constants/Landing'

import { useResponsiveLayout } from 'Hooks'

import Gallery from './Gallery'
import Title from './Title'

type Props = {
  onAction?: () => void
}

function LearnFromTopVoicesSection({ onAction }: Props) {
  const { isMobile } = useResponsiveLayout()

  return (
    <SectionContainer px={LANDING_CONTENT_PX}>
      <AppearingWrapper centered>
        <Column
          fullWidth
          gap={LANDING_SECTION_GAP}
          maxWidth={LANDING_CONTENT_WIDTH_PX}
          py={LANDING_SECTION_PY}
        >
          <Title />

          <Row fullWidth justifyCenter>
            <Gallery />
          </Row>

          <CTAHeadline
            centered
            mt={['-56px', '-56px', '-56px', '-56px', 0]}
            text="Are you ready to harness the power of golf for business?"
          />

          <Row fullWidth={isMobile} justifyCenter>
            <Button large width={isMobile ? 1 : undefined} onClick={onAction}>
              Book a Meeting
            </Button>
          </Row>
        </Column>
      </AppearingWrapper>
    </SectionContainer>
  )
}

export default LearnFromTopVoicesSection
